import { API } from 'api';

export const getCvUrl = (fileName: string): string =>
  // `https://abf-api.edonec.com/api/containers/CVs/download/${fileName}`;
  `${API}/api/containers/CVs/download/${fileName}`;
